
(function(window){

    // based on tags
    let discountGroups = [
        {
            id: '75cl',
            discounts: [
                {
                    qty: 3,
                    percentOff: 6
                },
                {
                    qty: 6,
                    percentOff: 12
                }
            ]
        },
        {
            id: '150cl',
            discounts: [
                {
                    qty: 3,
                    percentOff: 12
                }
            ]
        },
    ];

    document.addEventListener('DOMContentLoaded', () => {

        if (!window.productTags || !window.cartStart) {
            return;
        }

        const discountWidget = document.querySelector('.aa-volume-discount');

        if (!discountWidget) {
            return;
        }
        
        const discountGroup = discountGroups.find(dGroup => window.productTags.includes(dGroup.id));
        
        if (!discountGroup) {
            return;
        }

        // Draw discount widget
        discountWidget.classList.add('active');

        const barHolder = document.createElement('div');
        const potentialBar = document.createElement('div');
        const actualBar = document.createElement('div');
        
        barHolder.classList.add('bar-holder');
        potentialBar.classList.add('potential', 'bar');
        actualBar.classList.add('actual', 'bar');

        barHolder.appendChild(potentialBar);
        barHolder.appendChild(actualBar);
        discountWidget.appendChild(barHolder);


        // Add discount positions
        const maxQuantity = Math.max(...discountGroup.discounts.map(d => d.qty));
        discountGroup.discounts.sort((a,b) => (Number(a.qty) || 0) - (Number(b.qty) || 0));
        discountGroup.discounts.forEach(discount => {
            const threshold = document.createElement('div');
            threshold.classList.add('threshold');
            threshold.style.left = (100 * discount.qty / maxQuantity) + '%';

            const amountLabel = document.createElement('div');
            amountLabel.classList.add('amount'); 
            amountLabel.innerText = `Buy ${discount.qty}+`;
            
            const savingsLabel = document.createElement('div');
            savingsLabel.classList.add('savings'); 
            savingsLabel.innerText = `Save ${discount.percentOff}%`;

            threshold.appendChild(amountLabel);
            threshold.appendChild(savingsLabel);
            discountWidget.appendChild(threshold);

            discount.thresholdEl = threshold;
        });


        function getCartDiscountedItems(cart) {
            return cart.items.filter(item => item.tags && item.tags.includes(discountGroup.id)).map(item => item.quantity).reduce((sum, cur) => sum + parseInt(cur), 0);
        }

        let quantityInput = document.querySelector('input[name="quantity"]');
        let cart = window.cartStart;
        
        let productCount;

        function updateProductCount() {
            productCount = {
                actual: getCartDiscountedItems(cart),
                potential: getCartDiscountedItems(cart) + parseInt(quantityInput.value),
            }
            
            discountGroup.discounts.forEach(d => {
                d.thresholdEl.classList.toggle('reached', productCount.potential >= d.qty);
            });

            setTimeout(()=>{
                potentialBar.style.width = Math.min(100, (100 * productCount.potential / maxQuantity)) + '%';
                actualBar.style.width = Math.min(100, (100 * productCount.actual / maxQuantity)) + '%';
            },0);
        }

        if (window.subscribe && PUB_SUB_EVENTS) {
            window.subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
                
                const response = await fetch(window.Shopify.routes.root + '?section_id=cart-collections');
                const cartHTML = await response.text();

                const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
                const el = doc.querySelector('div');
                if (!el) throw new Error (`Missing div`);

                const fetchedCart = JSON.parse(el.textContent); 

                cart = fetchedCart;

                // Gross, but works
                quantityInput.value = 1;

                updateProductCount();
            });
        }
        else {
            console.log('do not have events');
        }

        if (quantityInput) {
            quantityInput.addEventListener('change', updateProductCount);
        }

        updateProductCount();
    });


})(window);
